import { render } from "./ComplexBackgroundCard.vue?vue&type=template&id=22d63ac9"
import script from "./ComplexBackgroundCard.vue?vue&type=script&lang=js"
export * from "./ComplexBackgroundCard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\raro\\raro-web\\argon-cel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__